import React from "react"
//import I18n from "i18n-js/index.js.erb"

export default class EmailCampaignPresenterCustomers extends React.Component{
  constructor(props){
    super(props);
    this.renderCustomerSelectBoxes = this.renderCustomerSelectBoxes.bind(this)
  };

  render(){
    return(
        <div>
          {this.renderAddButton()}
          {this.renderCustomerSelectBoxes()}
        </div>
    );
  };

  renderAddButton(){
    return(
      <div className="panel-body">
        <div className="pull-right" style={{ marginBottom: 15 }}><button type="button" className="btn btn-dark btn-sm" disabled={true} onClick={this.props.onAddField}><span className="ss-plus">&nbsp;</span> {I18n.t('add')}</button></div>
        <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 15, paddingTop: 0, marginTop: 10, marginBottom: 10 }}>{I18n.t('customer_details')}</h5>
      </div>
    );
  };

  renderCustomerSelectBoxes(){
    var customerSelectBoxes = this.props.customerSelectBoxes.map((select, idx) => {
      return (
        <div key={idx} className="col-md-12">
          <div className="col-md-2">
            <label style={{ marginTop: '15px' }}>{`${I18n.t('columns')}`}</label>
            <div className="form-group">
              <p>{select.value}</p>
            </div>
          </div>
          {this.renderField(select.value, select.id)}
        </div>
      )
    });

    return customerSelectBoxes
  }

  renderField(value, id = null){
    if (value == I18n.t('customer_fields')) {
      return this.renderAdditionalQuestions(id)
    }

    for (var i = 0, ilen = this.props.allCustomerFields.length; i < ilen; i++) {
      var field = this.props.allCustomerFields[i]
      if(field.column == value) {
        if (field.column_type == "Date Field") {
          return this.renderDateFieldOptions(value, id)
        } else if (field.column_type == "Number") {
          return this.renderNumberField(value, id)
        } else if(["Text Field", "Text Area", "Select Box"].includes(field.column_type)){
          return this.renderFieldSelect(value, id)
        }
      }
    }
  }

  renderAdditionalQuestions(id){
    var select = this.props.customerSelectBoxes.filter(select => select.id === id)[0]

    return (
      <div>
        <div className="col-md-2">
          <label style={{ marginTop: '15px' }}>{`${I18n.t('customer_fields')}*`}</label>
          <div className="form-group">
            <p>{select.additional_question_value}</p>
          </div>
        </div>
        {this.renderField(select.additional_question_value, id)}
      </div>
    )
  }

  renderDateFieldOptions(value, id){
    return (
      <div>
        <div className="col-md-4">
          <div className="form-group row">
            <div className="col-md-6">
              <label style={{ marginTop: '15px' }}>{`${I18n.t('from')}`}</label>
              <p>{this.props.customerFields[value].from ? this.props.customerFields[value].from : ''}</p>
            </div>

            <div className="col-md-6">
              <label style={{ marginTop: '15px' }}>{`${I18n.t('to')}`}</label>
              <p>{this.props.customerFields[value].to ? this.props.customerFields[value].to : ''}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderNumberField(value, id){
    return (
      <div>
        <div className="col-md-4">
          <div className="form-group row">
            <div className="col-md-6">
              <label style={{ marginTop: '15px' }}>{I18n.t("option")}</label>
              <p>{I18n.t(this.props.customerFields[value].option)}</p>
            </div>

            <div className="col-md-6">
              <label style={{ marginTop: '15px' }}>{I18n.t("number_string")}</label>
              <p>{this.props.customerFields[value].number}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderFieldSelect(value, id){
    if (value) {
      var selections = this.props.customerFields[value].map((selection, idx) => {
        return <li key={idx}>{selection}</li>
      })
      return (
        <div className="col-md-4">
          <label style={{ marginTop: '15px' }}>{`${I18n.t('column')} ${I18n.t('value')}*`}</label>
          <ul>
            {selections}
          </ul>
        </div>
      )
    }
  }
};
